module.exports = __webpack_public_path__ + "img/relacionescolor-induspac2.e18da0d9.png";